module.exports = __webpack_public_path__ + "img/flag_ua.d86e40c4.svg";